import { calcCellHeight } from "components/utils.js";
import { changeNestedArrKeyValueOnCondition, copyArr, searchNestedIterableItem } from "core/iterable_utils";

const applyLsrTableDataSelect = ({ state, action }) => {
	window.getSelection().removeAllRanges();
	if (action !== "contextMenu") state.multiSelectedLsrItems = [];

	state.filtredLsrTableData = state.filtredLsrTableData.map((section) => {
		if (section?._children) {
			section._children = section._children.map((item) => {
				if (state.selectedLsrItem?.key && item.key === state.selectedLsrItem.key) {
					item.selected = true;
					if (action !== "contextMenu") {
						item.multiSelected = false;
						const rowHeightMultiply = calcCellHeight({
							fontSize: state.expandOnSelect.fontSize,
							safeSpace: state.expandOnSelect.safeSpace,
							tableClass: state.expandOnSelect.lsrTableClass,
							clmName: state.expandOnSelect?.columnName,
							cellText: String(item?.name),
						});
						if (rowHeightMultiply > 1) item.rowHeightMultiply = rowHeightMultiply;
						if (state.selectedVor.file_name === item.vor_link_file_name) {
							state.multiSelectedVorItems = [];
							const { seekItem, seekCount, isFound } = searchNestedIterableItem({
								iterable: state.filtredVorTableData,
								isSeekRowCallback: (row) => row.num === item.vor_link_item_num?.[0],
								isPermittedRowCallback: (row) => true,
								isPermittedChildsLoopCallback: (row) => true,
								useRowHeightMultiply: true,
								breakAfterFirstMatch: true,
							});
							if (isFound) {
								state.selectedVorItem = seekItem;
								applyVorTableDataSelect({ state });
								state.vorTableScrollTop =
									(seekCount - state.displayOptions.tableRowsCountBeforeScroll) * state.displayOptions.vorTableRowHeight;
							}
						}
					}
				} else {
					if (action !== "contextMenu") {
						item.selected = false;
						item.multiSelected = false;
					}
					item.rowHeightMultiply = null;
				}
				return item;
			});
		}
		return section;
	});
};

const applyVorTableDataSelect = ({ state, action }) => {
	window.getSelection().removeAllRanges();
	if (action !== "contextMenu") state.multiSelectedVorItems = [];

	state.filtredVorTableData = state.filtredVorTableData.map((section) => {
		if (section?._children) {
			section._children = section._children.map((item) => {
				if (state.selectedVorItem?.key && item.key === state.selectedVorItem.key) {
					item.selected = true;
					if (action !== "contextMenu") {
						const rowHeightMultiply = calcCellHeight({
							fontSize: state.expandOnSelect.fontSize,
							safeSpace: state.expandOnSelect.safeSpace,
							tableClass: state.expandOnSelect.vorTableClass,
							clmName: state.expandOnSelect?.columnName,
							cellText: String(item?.name),
						});
						if (rowHeightMultiply > 1) item.rowHeightMultiply = rowHeightMultiply;
					}
				} else {
					if (action !== "contextMenu") {
						item.selected = false;
						item.multiSelected = false;
					}
					item.rowHeightMultiply = null;
				}
				return item;
			});
		}
		return section;
	});
};

const applyMultiTableSelect = ({ tableData, event, selectedtem, clickedRow, multiSelectedItems, isSelectAllowed }) => {
	let curMultiRows = [];

	let startAdding = false;
	let finishAdding = false;

	const pushToCurMultiRowsRecource = ({ tableData, reverse }) => {
		for (let iterRow of tableData) {
			if (startAdding && !finishAdding) curMultiRows.push(iterRow);
			if (iterRow?.key === selectedtem?.key) startAdding = true;
			if (iterRow?.key === clickedRow?.key) {
				finishAdding = true;
				break;
			}
			if (iterRow?._children) {
				if (reverse === true) {
					const reversedChildren = copyArr(iterRow?._children).reverse();
					pushToCurMultiRowsRecource({ tableData: reversedChildren, reverse });
				} else {
					pushToCurMultiRowsRecource({ tableData: iterRow?._children, reverse });
				}
			}
		}
	};

	if (event?.ctrlKey) {
		curMultiRows.push(clickedRow);
	} else if (event?.shiftKey) {
		pushToCurMultiRowsRecource({ tableData, reverse: false });
		if (curMultiRows?.length === 0) {
			startAdding = false;
			finishAdding = false;
			const reversedTableData = copyArr(tableData).reverse();
			pushToCurMultiRowsRecource({ tableData: reversedTableData, reverse: true });
		}
		if (!curMultiRows?.map((x) => x.id).includes(clickedRow?.id)) {
			curMultiRows.push(clickedRow);
		}
	}

	curMultiRows = curMultiRows.filter((row) => isSelectAllowed(row));

	for (let mltRow of curMultiRows) {
		let selectedVal;
		if (event?.ctrlKey) {
			if (multiSelectedItems?.find((x) => x.key === mltRow.key)) {
				multiSelectedItems = multiSelectedItems.filter((x) => x.key !== mltRow.key);
				selectedVal = false;
			} else {
				multiSelectedItems = [...multiSelectedItems, mltRow];
				selectedVal = true;
			}
		} else if (event?.shiftKey) {
			if (!multiSelectedItems?.find((x) => x.key === mltRow.key)) {
				multiSelectedItems.push(mltRow);
			}
			selectedVal = true;
		}

		tableData = changeNestedArrKeyValueOnCondition({
			arr: tableData,
			keySearch: "key",
			valSearch: mltRow.key,
			callback: (row) => {
				row.selected = false;
				row.multiSelected = selectedVal;
				return row;
			},
		});
	}

	return { multiSelectedItems, tableData };
};

const applyMultiLsrTableDataSelect = ({ state, clickedRow, event }) => {
	if (event?.shiftKey) window.getSelection().removeAllRanges();
	const copyTableData = copyArr(state.filtredLsrTableData);
	const { multiSelectedItems, tableData } = applyMultiTableSelect({
		tableData: copyTableData,
		event,
		clickedRow,
		selectedtem: state.selectedLsrItem,
		multiSelectedItems: state.multiSelectedLsrItems,
		isSelectAllowed: (row) => row?.model_name === "LocalEstimatesItems",
	});

	state.multiSelectedLsrItems = multiSelectedItems || [];
	state.filtredLsrTableData = tableData;
};

const applyMultiVorTableDataSelect = ({ state, clickedRow, event }) => {
	if (event?.shiftKey) window.getSelection().removeAllRanges();
	const copyTableData = copyArr(state.filtredVorTableData);
	const { multiSelectedItems, tableData } = applyMultiTableSelect({
		tableData: copyTableData,
		event,
		clickedRow,
		selectedtem: state.selectedVorItem,
		multiSelectedItems: state.multiSelectedVorItems,
		isSelectAllowed: (row) => row?.model_name === "VorWork",
	});

	state.multiSelectedVorItems = multiSelectedItems || [];
	state.filtredVorTableData = tableData;
};

export { applyLsrTableDataSelect, applyMultiLsrTableDataSelect, applyMultiVorTableDataSelect, applyVorTableDataSelect };
